(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hkgship-site-tools"] && !Shopify.designMode) return;
  try {
    document.getElementById('HkgSiteLanguage')?.addEventListener('submit', function () {
  this.querySelector('input[name="return_to"]').value = window.location.pathname + window.location.search + window.location.hash;
});
  } catch(e) { console.error(e); }
})();

})();
